import HomePage from "component/pages/HomePage"
import { SEO } from "component/seo/SEO"
import { graphql, PageProps } from "gatsby"
import { PageContextProps } from "libs/types/PageProps"
import React from "react"

const Page = (): JSX.Element => {
  return <HomePage />
}

export default Page

export const Head = (
  props: PageProps<unknown, PageContextProps>
): JSX.Element => {
  const { language } = props.pageContext

  if (language === "cs") {
    return (
      <SEO
        title="Mapheim - Nástroj pro tvorbu aplikací a interaktivních map"
        description="Sdělte 'co, kdy a kde' pomocí jediného kódu QR. Profesionální řešení dostupné pro každého"
        pathname="/"
      />
    )
  }
  return <SEO pathname="/" />
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
